module.exports = __webpack_public_path__ + "05ae9dc8dcbc8cfb22b6e61e6d70523d.png";